import React from "react";
import { ArrowRight } from "lucide-react";
import { sellCategories, wa } from "../mock";

export default function SellSection() {
  return (
    <section id="sell" data-testid="sell-section" className="home-section" style={{ scrollMarginTop: 120 }}>
      <div className="container">
        <div className="grid items-start gap-10 lg:grid-cols-[0.82fr_1fr]">
          <div className="reveal">
            <p className="eyebrow">Sell your assets</p>
            <h2 data-testid="sell-section-heading" className="mt-3 font-heading font-extrabold leading-[1.06]"
                style={{ color: "var(--green-950)", fontSize: "clamp(28px,3.6vw,42px)" }}>
              Sell surplus IT &amp; office equipment without market confusion
            </h2>
            <p className="mt-4 text-[17px]" style={{ color: "var(--muted)" }}>
              Kapatia Pvt Ltd buys used and excess assets from companies, offices, institutions,
              resellers and upgrade projects. Share a list or photos and we will review the
              commercial value, location and pickup requirement.
            </p>
            <a href={wa()} target="_blank" rel="noopener noreferrer" data-testid="sell-assets-whatsapp"
               className="kp-button mt-6 inline-flex items-center gap-2 rounded-xl px-6 py-3.5 font-heading font-bold text-white transition-transform hover:-translate-y-0.5"
               style={{ background: "linear-gradient(135deg, var(--green-800), var(--green-950))", boxShadow: "0 16px 32px rgba(45,106,79,0.22)" }}>
              Start Selling <ArrowRight size={18} />
            </a>
          </div>

          <div className="grid gap-4 sm:grid-cols-2">
            {sellCategories.map((c, i) => {
              const Icon = c.icon;
              return (
                <article key={c.title} data-testid={`asset-purchase-card-${i}`} className="reveal group relative overflow-hidden rounded-2xl p-6 transition-transform hover:-translate-y-1"
                         style={{ transitionDelay: `${i * 70}ms`,
                           background: "radial-gradient(circle at 90% 8%, rgba(13,106,67,0.6), transparent 36%), linear-gradient(135deg, var(--green-950), var(--green-800))",
                           border: "1px solid rgba(255,255,255,0.14)", boxShadow: "0 18px 38px rgba(45,106,79,0.2)" }}>
                  <span className="grid h-12 w-12 place-items-center rounded-xl"
                        style={{ background: "rgba(244,119,28,0.18)", color: "var(--orange-500)" }}>
                    <Icon size={24} />
                  </span>
                  <h3 data-testid={`asset-purchase-heading-${i}`} className="mt-4 font-heading text-[20px] font-extrabold text-white">{c.title}</h3>
                  <p data-testid={`asset-purchase-description-${i}`} className="mt-2 text-[14.5px]" style={{ color: "rgba(255,255,255,0.82)" }}>{c.desc}</p>
                </article>
              );
            })}
          </div>
        </div>

        {/* Dismantling feature */}
        <div className="reveal mt-10 grid items-center gap-8 rounded-2xl border p-6 md:p-8 lg:grid-cols-[0.85fr_1fr]"
             style={{ borderColor: "var(--line)",
                      background: "linear-gradient(135deg, rgba(255,231,156,0.7), rgba(255,253,247,0.96)), #fff",
                      boxShadow: "var(--shadow)" }}>
          <div className="overflow-hidden rounded-xl" style={{ background: "var(--green-900)" }}>
            <img src="https://customer-assets-4nw71qhi.emergentagent.net/job_kapatia-revamp/artifacts/n8j8tbsk_image.png"
                 alt="Kapatia team dismantling IT assets in a corporate office"
                 className="h-[320px] w-full object-cover transition-transform duration-700 hover:scale-105" />
          </div>
          <div>
            <p className="eyebrow">Office dismantling &amp; clearance</p>
            <h2 className="mt-3 font-heading font-extrabold leading-[1.06]"
                style={{ color: "var(--green-950)", fontSize: "clamp(26px,3.2vw,38px)" }}>
              Clear your old office setup with organized asset pickup
            </h2>
            <p className="mt-4 text-[17px]" style={{ color: "var(--muted)" }}>
              Kapatia supports office closure, relocation and renovation projects by coordinating
              reusable IT asset purchase, equipment pickup and clearance of laptops, desktops,
              networking, UPS, displays, AC units and office electronics.
            </p>
            <a href={wa()} target="_blank" rel="noopener noreferrer" data-testid="dismantling-whatsapp"
               className="kp-button mt-5 inline-flex items-center gap-2 rounded-full px-6 py-3.5 font-heading font-bold text-white transition-transform hover:-translate-y-0.5"
               style={{ background: "linear-gradient(135deg, #ff3f1f 0%, var(--orange-500) 58%, #ff9f1c 100%)", boxShadow: "0 16px 30px rgba(230,81,22,0.26)" }}>
              Discuss Dismantling <ArrowRight size={18} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
